import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ModalOptions, BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";

import { Refill } from "../../../../models/refill";
import { RefillsHandlerService } from "../../../../api-handlers/refills-handler.service";
import { EditRefillModalComponent } from "../../../../dialogs/edit-refill-modal/edit-refill-modal.component";

@Component({
  selector: "app-manage-refuels",
  templateUrl: "./manage-refuels.component.html",
  styleUrls: ["./manage-refuels.component.css"],
})
export class ManageRefuelsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  parkId: number;
  parkName: string;
  refillsTableDataSource: MatTableDataSource<Object>;
  refillsDisplayedColumns: string[] = [
    "rfl_id",
    "trv_id",
    "vhc_plate",
    "actions",
  ];
  noRefills: boolean = true;

  editRefillModalRef?: BsModalRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private modalService: BsModalService,
    private refillsService: RefillsHandlerService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.parkId = Number(params.get("parkId"));
      this.parkName = decodeURI(params.get("parkName"));

      this.getRefills();
    });
  }

  getRefills = async () => {
    try {
      const refillsRes: Refill[] = await this.refillsService.getRefillsByParkId(
        this.parkId + ""
      );

      this.refillsTableDataSource = new MatTableDataSource(
        refillsRes.reverse()
      );

      this.noRefills = refillsRes.length === 0;
      this.refillsTableDataSource.paginator = this.paginator;
      this.refillsTableDataSource.sort = this.sort;

      this.refillsTableDataSource.filterPredicate = (
        data: any,
        filter: string
      ): boolean =>
        data.vhc_plate ? data.vhc_plate.toLowerCase().includes(filter) : false;
    } catch (error) {
      this.snackBar.open(error.messsage, "Chiuda");
    } finally {
      this.changeDetector.detectChanges();
    }
  };

  applyPlateSearchFilter(filterVal) {
    this.refillsTableDataSource.filter = filterVal.trim().toLowerCase();
  }

  onRefillRowActionHandler(rowData) {
    const initialState: ModalOptions = {
      initialState: {
        refillId: rowData.rfl_id,
        km: rowData.rfl_kilometers,
        quantity: rowData.rfl_quantity,
        amount: rowData.rfl_amount,
        fuel_level: Number(rowData.rfl_fuel_level),
        made_at: new Date(rowData.rfl_made_at),
        fotoBox: rowData.rfl_box_pic,
        fotoRecive: rowData.rfl_recive_pic,
      },
      ignoreBackdropClick: true,
      keyboard: false,
    };

    this.editRefillModalRef = this.modalService.show(
      EditRefillModalComponent,
      initialState
    );

    this.editRefillModalRef.onHide.subscribe(this.getRefills);
  }
}
